// import { ORDER_STATUS_MAP } from '@/utils/mineConst'
import { ORDER_STATUS_MAP } from '@/utils/mineConst'
const { PAY_APART, PAY_APART_1 } = ORDER_STATUS_MAP
/**
 * 通过元素删除数组
 * @param {*} list
 * @param {*} value
 * @returns
 */
export const delArrayItemByEle = (list, value) => {
  if (!Array.isArray(list)) return []
  let index = -1
  for (let i = 0, len = list.length; i < len; i++) {
    if (list[i] === value) {
      index = i
      break
    }
  }
  if (index === -1) return list
  return list.slice(0, index).concat(list.slice(index, list.length))
}

/**
 *
 * @param {orders.OrderItemType} [opt]
 * @returns
 */
export const formatPrePayment = opt => {
  const { stepPayOrders, status, nowTime } = opt || {}
  if (!Array.isArray(stepPayOrders) || stepPayOrders.length === 0) return status
  const step2 = stepPayOrders[1]

  if (status === PAY_APART) {
    if (nowTime >= step2.payTimeLimitStart && nowTime < step2.payTimeLimitEnd) {
      return PAY_APART_1
    }
  }

  return status
}

export const isCanceledOrder = status => {
  return status === ORDER_STATUS_MAP.CANCELED_EXCEPTION || status === ORDER_STATUS_MAP.CANCELED
}
